import { de, enAU, enGB, enNZ, enUS, es, fr, it, nl, nlBE, pt, ptBR, sv } from 'date-fns/locale';
import type { LocaleList } from './types';

export const Locales: LocaleList = {
    de,
    deAT: de,
    deCH: de,
    deDE: de,
    enNZ,
    enAU: enAU,
    enIE: enGB,
    enSG: enGB,
    enHK: enGB,
    enDK: enGB,
    enFI: enGB,
    enGB: enGB,
    enCA: enUS,
    enUS: enUS,
    en: enUS,
    es,
    esAR: es,
    esCL: es,
    esCO: es,
    esPE: es,
    esES: es,
    esMX: es,
    fr,
    frBE: fr,
    frCH: fr,
    frFR: fr,
    frCA: fr,
    it,
    itIT: it,
    nl,
    nlBE: nlBE,
    nlNL: nl,
    ptBR: ptBR,
    ptPT: pt,
    pt,
    sv,
};
